import * as EventListener from "../../../common/helpers/event-listener";
import csrfToken from "../../../common/helpers/csrf-token";

const clickGift = () => {
    EventListener.click("gift-button", (element) => {
        document.querySelectorAll(".gift-button").forEach((element) => {
            element.disabled = true;
        });

        const categoryId = element.getAttribute("data-category-id");
        const activeCartPositionId = document.getElementById(
            "activeCartPositionId",
        ).value;

        oc.ajax("Settings::onAjax", {
            data: {
                _token: csrfToken,
                category_id: categoryId,
                active_cart_position_id: activeCartPositionId,
            },
            update: {
                "catalog/cart/cart-position-form/gift-products":
                    ".gift-products-wrapper",
            },
            complete: () => {
                giftsModal.showModal();
                document.querySelectorAll(".gift-button").forEach((element) => {
                    element.disabled = false;
                });
            },
        });
    });
};

const clickCloseGiftModal = () => {
    EventListener.click("gifts-modal-close", (element) => {
        giftsModal.close();
        element.disabled = false;
    });
};

const showGiftDescription = () => {
    EventListener.click("show-text", (element) => {
        const hiddenClass = "hidden";
        const showClass = "show";

        const giftDescriptionId = element.getAttribute(
            "data-gift-description-id",
        );

        const descriptionElement = document.getElementById(giftDescriptionId);
        const isNotOpened = descriptionElement.classList.contains(hiddenClass);

        if (isNotOpened) {
            element.classList.add(showClass);
            descriptionElement.classList.remove(hiddenClass);
        } else {
            element.classList.remove(showClass);
            descriptionElement.classList.add(hiddenClass);
        }

        element.disabled = false;
    });
};

clickGift();
clickCloseGiftModal();
showGiftDescription();
